module.exports = __webpack_public_path__ + "static/media/SignIn.608028a2.svg";